module.exports = __webpack_public_path__ + "static/media/0009.f1e42f87.jpg";